import { type UseMutationResult, useMutation } from '@tanstack/react-query';

import { tenantProvisioningService } from '@/services/control/tenant-provisioning-service';
import type {
  TenantAdmin,
  TenantAdminInput,
} from '@/types/control/tenant-provisioning';

import { adminMutationKeys } from '@/hooks/admin/query-keys';

/** Add another initial admin. Nothing cached here lists a tenant's admins yet. */
export function useAddTenantAdmin(
  tenantId: string
): UseMutationResult<TenantAdmin, Error, TenantAdminInput> {
  return useMutation<TenantAdmin, Error, TenantAdminInput>({
    mutationKey: adminMutationKeys.addTenantAdmin(tenantId),
    mutationFn: (admin) => tenantProvisioningService.addAdmin(tenantId, admin),
  });
}
